import { useEffect, useState } from 'react';

export const useDiscoverActiveIndex = (scrollRef, feedRef, itemCount) => {
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		const scroll = scrollRef.current;
		const feed = feedRef.current;

		if (!scroll || !feed || itemCount === 0) {
			return undefined;
		}

		const children = Array.from(feed.children);

		if (!children.length) {
			return undefined;
		}

		const visibilityByIndex = new Map(
			children.map((_, index) => [index, 0]),
		);

		const updateActiveIndex = () => {
			let nextIndex = -1;
			let bestRatio = 0;

			visibilityByIndex.forEach((ratio, index) => {
				if (ratio > bestRatio) {
					bestRatio = ratio;
					nextIndex = index;
				}
			});

			if (nextIndex < 0) {
				return;
			}

			setActiveIndex((current) => (current === nextIndex ? current : nextIndex));
		};

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const index = children.indexOf(entry.target);

					if (index >= 0) {
						visibilityByIndex.set(index, entry.intersectionRatio);
					}
				});

				updateActiveIndex();
			},
			{
				root: scroll,
				threshold: [0, 0.2, 0.35, 0.5, 0.65, 0.8, 1],
			},
		);

		children.forEach((child) => observer.observe(child));
		updateActiveIndex();

		return () => observer.disconnect();
	}, [feedRef, itemCount, scrollRef]);

	return activeIndex;
};
